import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import * as ExhibitionActions from './exhibition.actions';
import { ExhibitionV11Service } from '@api/rest';

@Injectable()
export class ExhibitionEffects {
  private actions$ = inject(Actions);
  private exhibitionHttp = inject(ExhibitionV11Service);


  loadExhibitions$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ExhibitionActions.loadExhibitions),
      switchMap(() => this.exhibitionHttp.restV11ExhibitionGet(true, true)
        .pipe(
          map(exhibitions => ExhibitionActions.loadExhibitionsSuccess({ exhibitions })),
          catchError(error => of(ExhibitionActions.loadExhibitionsFailure({ error })))
        )
      )
    );
  });

  setSelected: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType('@ngrx/router-store/navigated'),
      map((action: any) => action.payload.event.url.split('/')),
      filter(routes => routes.includes('exhibition')),
      map(routes => routes[ routes.findIndex(route => route === 'exhibition') + 1 ]),
      map(id => ExhibitionActions.setSelectedExhibition({ id }))
    )
  );

  getExhibition$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ExhibitionActions.getExhibition),
      switchMap(payload => this.exhibitionHttp.restV11ExhibitionIdGet(payload.id)
        .pipe(
          map(exhibition => ExhibitionActions.getExhibitionSuccess({ exhibition })),
          catchError(error => of(ExhibitionActions.getExhibitionFailure({ error })))
        )
      )
    );
  });

}
